// axios 请求模块

import axios from "axios";
import JSONBig from "json-bigint";
import router from "../router";
import { Toast, Dialog } from "vant";

const request = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "/api" : "", // 基础路径

  // transformResponse 允许自定义原始的响应数据（字符串）
  transformResponse: [
    function (data) {
      try {
        // 如果转换成功则返回转换的数据结果
        return JSONBig.parse(data);
      } catch (err) {
        // 如果转换失败，则包装为统一数据格式并返回
        return {
          data,
        };
      }
    },
  ],
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截器
request.interceptors.response.use(
  res => {
    // if (res.data.ack != undefined && res.data.ack == false) {
    //   Dialog.alert({
    //     message: res.data.message,
    //   }).then(() => {});
    // }
    return res;
  },
  async error => {
    if (error?.response?.status == 401 || !error?.response?.data) {
      Toast.fail("请登录");
      router.push("/login");
    }
  }
);
export default request;
